(function () {
  "use strict";

  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal, .mt-reveal-stagger");
    if (!els.length) return;
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-mt-count"));
    if (isNaN(target)) return;
    var decimals = el.getAttribute("data-mt-decimals") ? parseInt(el.getAttribute("data-mt-decimals"), 10) : 0;
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = value.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
    requestAnimationFrame(step);
  }

  function initContadores() {
    var els = document.querySelectorAll("[data-mt-count]");
    if (!els.length) return;
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute("data-mt-count"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll(".mt-faq-item");
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector(".mt-faq-pregunta");
      var panel = item.querySelector(".mt-faq-respuesta");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var abierto = item.classList.contains("mt-abierto");
        items.forEach(function (otro) {
          otro.classList.remove("mt-abierto");
          var otroPanel = otro.querySelector(".mt-faq-respuesta");
          if (otroPanel) otroPanel.style.maxHeight = "";
        });
        if (!abierto) {
          item.classList.add("mt-abierto");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  function initGaleriaProducto() {
    var wraps = document.querySelectorAll("[data-mt-galeria-producto]");
    wraps.forEach(function (wrap) {
      var principal = wrap.querySelector("[data-mt-imagen-principal]");
      var botones = wrap.querySelectorAll("[data-mt-miniatura]");
      if (!principal || !botones.length) return;
      botones.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var src = btn.getAttribute("data-mt-miniatura");
          var srcset = btn.getAttribute("data-mt-miniatura-srcset");
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          botones.forEach(function (b) { b.classList.remove("mt-activa"); });
          btn.classList.add("mt-activa");
        });
      });
    });
  }

  function initCantidad() {
    var wraps = document.querySelectorAll("[data-mt-cantidad]");
    wraps.forEach(function (wrap) {
      var input = wrap.querySelector("input");
      var menos = wrap.querySelector("[data-mt-menos]");
      var mas = wrap.querySelector("[data-mt-mas]");
      if (!input) return;
      if (menos) menos.addEventListener("click", function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
      });
      if (mas) mas.addEventListener("click", function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
      });
    });
  }

  function initComparador() {
    var wraps = document.querySelectorAll("[data-mt-comparador]");
    wraps.forEach(function (wrap) {
      var imgs = wrap.querySelector(".mt-comparador-imgs");
      var clip = wrap.querySelector("[data-mt-comparador-clip]");
      var linea = wrap.querySelector("[data-mt-comparador-linea]");
      var slider = wrap.querySelector("[data-mt-comparador-slider]");
      if (!imgs || !clip || !linea || !slider) return;

      function ajustarAncho() {
        imgs.style.setProperty("--mt-comparador-ancho", imgs.offsetWidth + "px");
      }
      function aplicar(valor) {
        clip.style.width = valor + "%";
        linea.style.left = valor + "%";
      }

      ajustarAncho();
      aplicar(slider.value);

      slider.addEventListener("input", function () {
        aplicar(slider.value);
      });
      window.addEventListener("resize", ajustarAncho);
    });
  }

  function initPackCards() {
    var selectores = document.querySelectorAll("[data-mt-pack-selector]");
    selectores.forEach(function (grupo) {
      var form = grupo.closest("form");
      if (!form) return;
      var cards = grupo.querySelectorAll("[data-mt-pack-variant]");
      cards.forEach(function (card) {
        card.addEventListener("click", function () {
          cards.forEach(function (c) { c.classList.remove("mt-pack-activa"); });
          card.classList.add("mt-pack-activa");

          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = card.getAttribute("data-mt-pack-variant");

          var precioEl = form.querySelector("[data-mt-precio-actual]");
          if (precioEl) precioEl.textContent = card.getAttribute("data-mt-pack-price");

          var comparadoEl = form.querySelector("[data-mt-precio-comparado]");
          var compare = card.getAttribute("data-mt-pack-compare");
          if (comparadoEl) {
            if (compare) {
              comparadoEl.textContent = compare;
              comparadoEl.style.display = "";
            } else {
              comparadoEl.style.display = "none";
            }
          }

          var disponible = card.getAttribute("data-mt-pack-disponible") === "true";
          var boton = form.querySelector("[data-mt-comprar]");
          if (boton) {
            boton.disabled = !disponible;
            boton.textContent = disponible
              ? boton.getAttribute("data-mt-texto-disponible")
              : boton.getAttribute("data-mt-texto-agotado");
          }
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll("[data-mt-producto-form]");
    forms.forEach(function (form) {
      var dataEl = form.querySelector("[data-mt-variantes-json]");
      var selects = form.querySelectorAll("[data-mt-opcion]");
      if (!dataEl || !selects.length) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      function variantePorOpciones() {
        var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
        return variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
      }

      function actualizar() {
        var variante = variantePorOpciones();
        if (!variante) return;
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variante.id;
        var precioEl = form.querySelector("[data-mt-precio-actual]");
        var comparadoEl = form.querySelector("[data-mt-precio-comparado]");
        var boton = form.querySelector("[data-mt-comprar]");
        if (precioEl && variante.price) precioEl.textContent = variante.priceFormatted;
        if (comparadoEl) {
          if (variante.compareAtPriceFormatted) {
            comparadoEl.textContent = variante.compareAtPriceFormatted;
            comparadoEl.style.display = "";
          } else {
            comparadoEl.style.display = "none";
          }
        }
        if (boton) {
          boton.disabled = !variante.available;
          boton.textContent = variante.available ? boton.getAttribute("data-mt-texto-disponible") : boton.getAttribute("data-mt-texto-agotado");
        }
      }

      selects.forEach(function (select) { select.addEventListener("change", actualizar); });
    });
  }

  onReady(function () {
    initReveal();
    initContadores();
    initFaq();
    initGaleriaProducto();
    initCantidad();
    initVariantes();
    initPackCards();
    initComparador();
  });
})();
